// import React, { useState } from 'react';

// const ServiceCard = ({ title, shortDesc, fullDesc, image }) => {
//   const [expanded, setExpanded] = useState(false);

//   const toggleExpand = () => {
//     setExpanded(!expanded);
//   };

//   const scrollToContact = (e) => {
//     e.stopPropagation();
//     const contactSection = document.getElementById("contact");
//     if (contactSection) {
//       contactSection.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   return (
//     <div
//       onClick={toggleExpand}
//       style={{
//         width: 300,
//         margin: '15px',
//         border: '1px solid #ddd',
//         borderRadius: '10px',
//         boxShadow: expanded
//           ? '0 6px 20px rgba(0,0,0,0.2)'
//           : '0 4px 10px rgba(0,0,0,0.1)',
//         cursor: 'pointer',
//         backgroundColor: '#fff',
//         transition: 'all 0.3s ease',
//         overflow: 'hidden'
//       }}
//     >
//       <img
//         src={image}
//         alt={title}
//         style={{
//           width: '100%',
//           height: '200px',
//           objectFit: 'cover',
//           borderTopLeftRadius: '10px',
//           borderTopRightRadius: '10px'
//         }}
//       />
//       <div style={{ padding: '16px' }}>
//         <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>{title}</h3>
//         <p style={{ fontSize: '14px', color: '#555' }}>{shortDesc}</p>

//         {expanded && (
//           <div style={{
//             marginTop: '12px',
//             fontSize: '14px',
//             color: '#333',
//             transition: 'opacity 0.4s ease',
//           }}>
//             <p>{fullDesc}</p>
//             <button
//               onClick={scrollToContact}
//               style={{
//                 marginTop: '12px',
//                 backgroundColor: '#003366',
//                 color: '#fff',
//                 border: 'none',
//                 padding: '10px 16px',
//                 borderRadius: '5px',
//                 cursor: 'pointer'
//               }}
//             >
//               Get Quote
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ServiceCard;



// import React from 'react';

// const ServiceCard = ({ title, shortDesc, fullDesc, image, id }) => {
//   const scrollToGallery = (e) => {
//     e.stopPropagation();
//     const target = document.getElementById(id);
//     if (target) {
//       target.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   return (
//     <div
//       style={{
//         width: '300px',
//         margin: '15px',
//         border: '1px solid #ddd',
//         borderRadius: '10px',
//         boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
//         backgroundColor: '#fff',
//         transition: 'transform 0.3s ease',
//         cursor: 'pointer',
//       }}
//       onClick={scrollToGallery}
//     >
//       <img
//         src={image}
//         alt={title}
//         style={{
//           width: '100%',
//           height: '180px',
//           objectFit: 'cover',
//           borderTopLeftRadius: '10px',
//           borderTopRightRadius: '10px',
//         }}
//       />
//       <div style={{ padding: '16px', textAlign: 'left' }}>
//         <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>{title}</h3>
//         <p style={{ fontSize: '14px', color: '#555' }}>{shortDesc}</p>
//         <button
//           style={{
//             marginTop: '12px',
//             backgroundColor: '#003366',
//             color: '#fff',
//             border: 'none',
//             padding: '10px 16px',
//             borderRadius: '5px',
//             cursor: 'pointer',
//           }}
//         >
//           View Gallery
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ServiceCard;


import React from 'react';

import { useNavigate,Link} from 'react-router-dom';

const ServiceCard = ({ title, shortDesc, fullDesc, image, id }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/services/${id}`);
  };

  return (
    <div
      onClick={handleClick}
      style={{
        width: '300px',
        margin: '15px',
        border: '1px solid #ddd',
        borderRadius: '10px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
        backgroundColor: '#fff',
        cursor: 'pointer',
        transition: 'transform 0.3s ease',
      }}
    >
      <img
        src={image}
        alt={title}
        style={{
          width: '100%',
          height: '180px',
          objectFit: 'cover',
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
        }}
      />
      <div style={{ padding: '16px', textAlign: 'left' }}>
        <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>{title}</h3>
        <p style={{ fontSize: '14px', color: '#555' }}>{shortDesc}</p>
       

        <Link class="cssbuttons-io-button" to={`/services/${id}`}>
          View Gallery
          <div class="icon">
            <svg
              height="24"
              width="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 0h24v24H0z" fill="none"></path>
              <path
                d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
                fill="currentColor"
              ></path>
            </svg>
          </div>
        </Link>

      
      </div>
    </div>
  );
};

export default ServiceCard;
